import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  ReadSnippetStatus,
  UpdateSnippetAnalyticsMode,
} from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type UpdateSnippetAnalyticsModeParams = {
  organizationId: string;
  data: UpdateSnippetAnalyticsMode;
};

export const updateSnippetAnalyticsMode = async (
  params: UpdateSnippetAnalyticsModeParams,
): Promise<ReadSnippetStatus> => {
  return await tinctApi.organizations.updateSnippetAnalyticsMode(
    params.organizationId,
    params.data,
  );
};

export const useUpdateSnippetAnalyticsMode = (
  options?: Omit<
    UseMutationOptions<
      ReadSnippetStatus,
      ApiError,
      UpdateSnippetAnalyticsModeParams
    >,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSnippetAnalyticsMode,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['organization', args[1].organizationId],
      });
      queryClient.invalidateQueries({
        queryKey: ['snippet-verification-result', args[1].organizationId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
